import React, { useCallback, useEffect } from "react";
// import PropTypes from 'prop-types';
import { useLocation } from "react-router-dom";
import clsx from "clsx";
import i18n from "../../lib/i18n";
import { useRoutePath } from "../../hooks/useRoutePath";
import { useSelector } from "react-redux";
import menuService from "@services/menuService";
import { Breadcrumbs, Typography, Link, Grid } from "@mzc-pdc/ui";

const BreadcrumbsWithRouterPath = ({ isAdmin }) => {
    const routePath = useRoutePath();
    const location = useLocation();
    const newPath = menuService.breadcrumbs(routePath.match.url);
    const { spaceId, projectId } = menuService.parse(location.pathname);
    const splitPath = newPath.replace(/^\//, "").split("/");

    const navigator = useSelector(({ navigator }) => navigator);

    const list = splitPath.map((path, index) => {
        const path_ = path.replace(/^[a-z]/, (c) => c.toUpperCase());
        const i18nKey = `common::label::${path_}`;
        const isKeyExist = i18n.exists(i18nKey);
        const isLastItem = index === splitPath.length - 1;
        let pathValue = path_;
        if (isKeyExist) pathValue = i18n.t(i18nKey);
        const LinkComponent = isLastItem ? Typography : Link;

        if (pathValue === "Sharebox") {
            pathValue = "Shared Box";
        }
        if (pathValue === "Shared History") {
            pathValue = "Shared Histories";
        }
        if (pathValue === "Meetings_old") {
            pathValue = "Meetings";
        }
        if (pathValue === "Project-list") {
            pathValue = "Projects";
        }
        if (pathValue === "Assigned-groups") {
            pathValue = "Groups";
        }
        if (pathValue === "Assigned-users") {
            pathValue = "Users";
        }
        if (menuService.paths.assetsCollectionsSearch(spaceId, projectId).includes(newPath) && pathValue === "Search") {
            pathValue = "Collections Search Results";
        }
        if (
            index > 0 &&
            splitPath[index - 1] === "contents" &&
            !["videos", "photos", "music", "people"].includes(splitPath[index])
        ) {
            pathValue = navigator?.contents?.data?.find(({ id }) => id === path)?.name || "";
        }

        return (
            <Link
                color={isLastItem ? "text.secondary" : "primary"}
                href={
                    `${isAdmin ? "admin" : ""}/spaces/${spaceId}/${projectId ? `projects/${projectId}/` : ""}` +
                    splitPath.slice(0, index + 1).join("/")
                }
                underline="hover"
                variant="body3"
                key={index}
            >
                {pathValue}
            </Link>
        );
    });

    const { asset, project } = useSelector((state) => state);
    const assetProject = asset.data && asset.data.project;
    // console.log('assetProject', assetProject)
    const differentProject = (project && project.id) !== (assetProject && assetProject.id) || false;
    // console.log('location', location)

    return (
        <>
            <Grid container className={"breadcrumb"}>
                <Breadcrumbs separator={"/"}>{list}</Breadcrumbs>
                {assetProject && location.pathname.includes("assets/assets/") && differentProject ? (
                    <span className="badge-project">
                        <strong>Asset’s Project</strong>
                        <i className="sprite sprite-info-transparent"></i>
                        <span>{assetProject.name || "-"}</span>
                    </span>
                ) : (
                    ""
                )}
            </Grid>
        </>
    );
};
// BreadCrumb.propType = {
// };

export default BreadcrumbsWithRouterPath;
